import { useDispatch } from 'react-redux';
import { FilterValuesStrings } from '../pages/dashboard.page';
import { useDashboardFiltersSelector, setFilters, clearFilters } from '../store/dashboard-filters.slice';

export const useDashboardFilters = () => {
	const dispatch = useDispatch();
	const { filters } = useDashboardFiltersSelector();

	const setDashboardFilters = (newFilters: FilterValuesStrings) => {
		dispatch(setFilters(newFilters));
	};

	const clearDashboardFilters = () => {
		dispatch(clearFilters());
	};

	return {
		filters,
		setDashboardFilters,
		clearDashboardFilters,
	};
};
